export default "__VITE_ASSET__FmHl9dto__"